import PCLNAnalytics from '@pcln/analytics'
import axios from 'axios'
import get from 'lodash/get'

const typeaheadApiRequest = (value) => {
  return axios
    .get(`/svcs/ac/index/flights/${value}/0/9/0/0`)
    .then((response) => {
      return get(response, 'data.searchItems', [])
    })
    .catch((err) => {
      PCLNAnalytics.logError({
        message: err.message,
        severity: 3,
        stack: 'pages/Landing typeaheadApiRequest',
      })
    })
}

export { typeaheadApiRequest }
